import * as React from "react";
import type { SVGProps } from "react";
const SvgSkiLiftChairFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 7c-.4 0-.79-.25-.94-.65-.19-.52.07-1.09.58-1.29l8.01-3c.52-.19 1.09.07 1.29.59.19.52-.07 1.09-.58 1.29L13 5.198V9h5.03c1.34 0 2.5.94 2.81 2.29l1.07 4.55c.18.79 0 1.6-.49 2.22-.365.458-.867.77-1.42.888v1.112c0 1.07-.87 1.94-1.94 1.94H5.94C4.87 22 4 21.13 4 20.06v-1.104a2.42 2.42 0 0 1-1.45-.896c-.5-.63-.67-1.44-.49-2.22l1.07-4.55C3.45 9.94 4.6 9 5.94 9H11V5.948l-2.65.992C8.23 6.98 8.12 7 8 7M4.5 17v-1.02c0-1.09.84-1.98 1.87-1.98h11.26c1.03 0 1.87.89 1.87 1.98V17h.03c.17 0 .28-.1.34-.18.11-.14.15-.33.11-.52l-1.07-4.55c-.1-.44-.46-.75-.87-.75H5.95c-.41 0-.76.31-.87.75L4.01 16.3c-.04.19 0 .38.11.52a.44.44 0 0 0 .38.18m13 0H6.51v-1H17.5zM6.01 19v1.06L18.07 20l-.03-1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSkiLiftChairFront;
